module.exports = __webpack_public_path__ + "assets/normal/images/logo.e89b7d39.png";